<script>
import ContactForm from '../../components/contactForm.vue';
import Loading from '../../components/loading.vue';

export default {
    name: "starList",
    data() {
        return {
            data: [],
            page: 1,
            allPage: 1,
            isLoading: false,
        };
    },
    computed: {},
    components: {
        ContactForm,
        Loading
    },
    mounted() {
        this.getData();
    },
    destroyed() {},
    watch: {
        '$route.query': {
            handler: function (value) {
                this.data = [];
                this.getData();
            }
        },
    },
    methods: {
        getData() {
            if (this.isLoading) { 
                return false;
            }
            this.isLoading = true;
            this.$store.dispatch('getTalentList', {
                category_id: this.$route.query.id,
                limit: 12,
                page: this.page,
                keywords: this.$route.query.s,
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    this.data = this.data.concat(result.data.list);
                    this.allPage = result.data.last_page;
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
        getMore() { 
            if (this.isLoading) { 
                return false;
            }
            this.page++;
            this.getData();
        }
    },
};
</script>

<template>
    <div class="star_list">
        <div class="wrapper layout_main">
            <div class="list flex flex_wrap">
                <div class="item" v-for="(item, index) in data" :key="index">
                    <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
                    <p class="name position_100 layout_flex_center">{{ item.name }}</p>
                </div>
            </div>
            <Loading v-if="isLoading"/>
            <p class="no_more" v-else-if="data.length == 0">暂无更多内容</p>
            <p class="no_more" v-else-if="page == allPage">已经到底了</p>
            <div class="flex justify_end" v-else>
                <div class="layout_btn_more" @click="getMore">了解更多</div>
            </div>
        </div>
        <ContactForm from="人才"/>
    </div>
</template>

<style scoped lang="scss">
.wrapper{
    padding-bottom: .7rem;
    @media only screen and (max-width: 750px) {
        padding-top: .3rem;
    }
}
.list{
    gap: .2rem;
    @media only screen and (max-width: 750px) {
        flex-wrap: nowrap;
        flex-direction: column;
    }
    .item{
        width: 2.85rem;
        // height: 2.85rem;
        position: relative;
        overflow: hidden;
        // cursor: pointer;
        @media only screen and (max-width: 750px) {
            width: 100%;
        }
        .bg{
            transition: transform .3s;
            padding-bottom: 100%;
            height: 0;
        }
        .name{
            background: rgba($color: #000000, $alpha: .2);
            font-size: .22rem;
            color: #fff;
            opacity: 0;
            transition: opacity .3s;
            @media only screen and (max-width: 750px) {
                opacity: 1;
                background: none;
                text-shadow: 0 .0rem .2rem rgba($color: #000, $alpha: 1);
                font-size: .26rem;
                height: auto;
                top: 5.8rem;
            }
        }
        &:hover{
            .bg{
                transform: scale(1.1);
            }
            .name{
                opacity: 1;
            }
        }
    }
}
</style>